import {
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  TextField,
  Grid,
  MenuItem,
} from '@mui/material'
import React from 'react'

const Sclera = ({ moduleValues, setModuleValues, side }) => (
  <Grid item xs={12} lg={6}>
    <FormControl fullWidth>
      <InputLabel>Sclera</InputLabel>
      <Select
        value={moduleValues?.[`Sclera (${side})`] ?? ''}
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            [`Sclera (${side})`]: e.target.value,
          }))
        }
        label="Sclera"
      >
        {[
          'Jaundice',
          'Injected',
          'Haemorrhage',
          'Foreign Body Present',
          'Laceration',
          'Normal',
        ].map((x) => (
          <MenuItem key={x} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default Sclera
